import { Controller } from "@hotwired/stimulus"

// A button that shows and hides one panel. Disclosure pattern (WCAG 2.1 AA):
// a real <button> with aria-expanded controls the panel via aria-controls,
// and a closed panel is hidden, so it is out of the tab order and out of the
// accessibility tree. Nothing is remembered between pages — that is what
// filter_disclosure_controller.js is for.
//
// The state is a value on the element, so something outside can open or
// close every panel on a page at once by writing the data attribute, without
// having to know which button belongs to which panel.
export default class extends Controller {
  static targets = ["trigger", "panel"]
  static values = { open: Boolean }

  toggle() {
    this.openValue = !this.openValue
  }

  openValueChanged() {
    this.panelTarget.hidden = !this.openValue
    this.triggerTarget.setAttribute("aria-expanded", String(this.openValue))
  }
}
